var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootcamp-video"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVideoLoading),expression:"isVideoLoading"}],staticClass:"bootcamp-video__spinner-wrapper"},[_c('ActionLoader')],1),_c('MediaDelegate',_vm._b({on:{"is-loading":_vm.setIsLoading}},'MediaDelegate',{
      parentType: 'bootcamp',
      content: Object.assign({}, _vm.video, {type: 'video'}),
      userCompletionStatus: _vm.videoStatus,
    },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }